import React from "react";
import {Icon} from "antd";

const TransformLoader = () => {
    return (
        <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <Icon
                type="loading"
                style={{
                    color: 'red',
                    fontSize: 48
                }}
            />
        </div>
    )
}

export default TransformLoader;